/**
 * EN-4403: why a V2 order is held or waits at its provider, in words the API
 * already made readable ("Held: waiting for stock replenishment"). Legacy
 * orders leave `status_reason` off.
 */
import type { OrderStatusReason } from '@skupreme/api-contracts/core';

export type StatusReasonOrder = {
  status_reason?: OrderStatusReason | null;
  /** The detail only: every current reason, the lead one first. */
  status_reasons?: OrderStatusReason[];
};

/* A stall is the same flag the Past SLA badge shows, so it is not repeated. */
const SHOWN_BY_PAST_SLA = 'stall';

/** The reason a row or card shows next to its badges, or null. */
export function getStatusReason(
  order: StatusReasonOrder | null | undefined,
  hasPastSla = false,
): OrderStatusReason | null {
  const reason = order?.status_reason;

  if (!reason?.message) {
    return null;
  }

  return hasPastSla && reason.source === SHOWN_BY_PAST_SLA ? null : reason;
}

/** Every current reason for the detail card, the lead one first. */
export function getStatusReasons(
  order: StatusReasonOrder | null | undefined,
  hasPastSla = false,
): OrderStatusReason[] {
  const all =
    order?.status_reasons ??
    (order?.status_reason ? [order.status_reason] : []);

  return all.filter(
    reason =>
      !!reason?.message && !(hasPastSla && reason.source === SHOWN_BY_PAST_SLA),
  );
}

/* "Held: waiting for stock replenishment" → "Held" and the rest. */
export function splitStatusReason(message: string): {
  title: string;
  detail: string;
} {
  const at = message.indexOf(': ');

  return at > 0
    ? { title: message.slice(0, at), detail: message.slice(at + 2) }
    : { title: message, detail: '' };
}
